/* eslint-disable no-restricted-globals */
import {
  Autocomplete,
  Box,
  Card,
  Divider,
  Grid,
  List,
  ListItem,
  TextField,
  Switch,
  FormControlLabel,
  Stack,
} from "@mui/material";
import MDBox from "components/MDBox";
import React, { useState, useEffect, useCallback } from "react";
import DashboardLayout from "utils/LayoutContainers/DashboardLayout";
import DashboardNavbar from "utils/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import { useSelector, useDispatch } from "react-redux";
import { getFilterDates } from "utils/HelperFunctions";
import { enqueueSnackbar } from "notistack";
import { convertBEData, convertBEDataForCsv } from "utils/PerformanceHelperFunctions";
import { postAPICall, getAPICall } from "lib/callApi";
import { FILTER_PARAMS, DATE_FILTER_OPTIONS, COMPANY_CONFIG, CONFIG_NAME } from "lib/constants";
import MDBadgeDot from "components/MDBadgeDot";
import MixedChart from "utils/Charts/MixedChart";
import { generateColorFromString } from "utils/GenerateColorFromString/GenerateColorFromString";
import MDTypography from "components/MDTypography";
import moment from "moment";
import MDDatePicker from "components/MDDatePicker";
import { displayDate } from "utils/Date";
import FilterModal from "./components/FilterModal";
import { performanceAction } from "../../redux/slice/performance";
import Loader from "../../utils/Loader";
import ListingTable from "./components/ListingTable";
import BreakDownCharts from "./components/BreakDownCharts";
import ConversionFunnel from "./components/ConversionFunnel";
import ExportReportModal from "./components/ExportData/ExportDataModal";
import PerformanceAnalytics from "./components/PerformanceAnalytics";

function Performance() {
  const dispatch = useDispatch();
  const loginUserState = useSelector((state) => state.loginUser.loginUserState);
  const defaultDaysOfWeek = loginUserState.workingDays;
  let qparams = new URLSearchParams(window.location.search);
  let QParamsObj = {
    location: qparams?.getAll("location") || [],
    team: qparams?.getAll("team") || [],
    user: qparams?.getAll("user") || [],
    role: qparams?.getAll("role") || [],
    reportsTo: qparams?.getAll("reportsTo") || [],
    dateFilter: qparams?.get("dateFilter") || "This Week",
    daysOfWeek: qparams?.get("daysOfWeek") || defaultDaysOfWeek,
  };

  const { performance, loading } = useSelector((state) => state.performance);
  const [filterComponents, setFilterComponents] = useState([]);

  const [dateFilter, setDateFilter] = useState("This Week");
  const [workingDays, setWorkingDays] = useState({
    0: 0,
    1: 1,
    2: 1,
    3: 1,
    4: 1,
    5: 1,
    6: 0,
  });
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filters, setFilters] = useState({
    location: [],
    team: [],
    user: [],
    role: [],
    reportsTo: [],
    dateFilter: "This Week",
    daysOfWeek: defaultDaysOfWeek,
  });
  const [options, setOptions] = useState({});
  const [isFilterEdited, setIsFilterEdited] = useState(false);
  const [activePerformanceIndex, setActivePerformanceIndex] = useState(0);
  const [activeUserId, setActiveUserId] = useState("all");
  const [listingData, setListingData] = useState([]);
  const [graphData, setGraphData] = useState({
    labels: [],
    datasets: [],
  });
  const [pieChartData, setPieChartData] = useState({
    kpiBreakdown: {
      labels: [],
      data: [],
      graphKpiColors: [],
    },

    achivedPointsBreakdown: {
      labels: [],
      data: [],
      graphKpiColors: [],
    },
  });

  const [tableData, setTableData] = useState([]);
  const [customDate, setCustomDate] = useState({
    startDate: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
    endDate: moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
  });
  const [createNewView, setCreateNewView] = useState(false);
  const [displayTrend, setDisplayTrend] = useState(true);
  const [graphDisplay, setGraphDisplay] = useState("achievedPointsBreakdown");
  const [totalDisplay, setTotalDisplay] = useState(0);
  const [filterDates, setFilterDates] = useState({});
  const [csvData, setCsvData] = useState({ data: [], columns: [], title: "" });
  const [isExportDataModalOpen, setIsExportDataModalOpen] = useState(false);
  const handleExportDataModalClose = useCallback(() => {
    setIsExportDataModalOpen((prev) => !prev);
  }, []);

  const fetchPerformance = (optionObj, userId) => {
    const dates =
      optionObj.dateFilter === "Custom" && customDate
        ? customDate
        : getFilterDates(
            optionObj.dateFilter,
            loginUserState.timezone,
            loginUserState.fiscalYearStart
          );

    setFilterDates(dates);

    const payloadBody = {
      dateType:
        optionObj.dateFilter?.toLowerCase().indexOf("quarter") < 0 &&
        optionObj.dateFilter?.toLowerCase().indexOf("year") < 0
          ? 1
          : 2,
      dateFilter: optionObj.dateFilter,
      startDate: dates.startDate,
      endDate: dates.endDate,
      timezone: loginUserState.timezone,
      filter: {
        locationList: optionObj?.location || [],
        teamList: optionObj?.team || [],
        roleList: optionObj?.role || [],
        userList: optionObj?.user || [],
        reportsToList: optionObj?.reportsTo || [],
        reportsOfUser: userId,
        daysOfWeek: optionObj?.daysOfWeek || defaultDaysOfWeek,
      },
    };
    dispatch(performanceAction.getPerformanceRequest(payloadBody));
  };

  useEffect(() => {
    const clearPerformance = () => dispatch(performanceAction.clearPerformanceState());
    window.addEventListener("beforeunload", clearPerformance);
    const savedDefaultDate = JSON.parse(localStorage.getItem("performanceCustomDate"));
    if (savedDefaultDate) {
      setCustomDate({ ...savedDefaultDate });
    }

    return () => {
      window.removeEventListener("beforeunload", clearPerformance);
      clearPerformance();
    };
  }, []);

  const refreshData = (refreshOpts) => {
    if (performance?.reportingUsers?.length > 0) {
      const {
        listingData: structuredListingData,
        structuredTableData,
        structuredGraphData,
        structuredPieChartData,
      } = convertBEData(
        performance.reportingUsers,
        activeUserId,
        activePerformanceIndex,
        filters.dateFilter,
        loginUserState.dateFormat,
        loginUserState.timezone || moment.tz.guess(),
        filters.daysOfWeek || defaultDaysOfWeek,
        graphDisplay,
        refreshOpts
      );
      if (filters?.user?.length > 0) {
        structuredTableData.splice(0, 1);
      }
      setListingData(structuredListingData);
      setTableData(structuredTableData);
      setGraphData(structuredGraphData);
      if (refreshOpts.refreshPie) {
        setPieChartData(structuredPieChartData);
      }

      if (structuredGraphData.datasets.length) {
        const total = structuredGraphData.datasets[0].total || 0;
        setTotalDisplay(total);
      }
    }
  };

  const getCsvData = async () => {
    let data = [];
    let exportColumns = [];

    if (performance?.reportingUsers?.length > 0) {
      const { kpiList, dataToExport } = convertBEDataForCsv(performance.reportingUsers);
      exportColumns = [{ id: "kpi", displayName: "KPI" }];

      dataToExport.forEach((user) => {
        exportColumns.push({ id: `${user.id}_kpis`, displayName: `${user.name} (KPIs)` });
        exportColumns.push({ id: `${user.id}_points`, displayName: `${user.name} (points)` });
      });

      data = kpiList.map(([kpiId, kpiName]) => {
        const rowData = dataToExport.reduce((obj, user) => {
          const userKpiData = user.kpiData[kpiId];
          obj[`${user.id}_kpis`] = userKpiData ? userKpiData.count : 0;
          obj[`${user.id}_points`] = userKpiData ? userKpiData.points : 0;
          return obj;
        }, {});
        rowData.kpi = kpiName;
        return rowData;
      });
    }

    const dates =
      filters.dateFilter === "Custom" && customDate
        ? customDate
        : getFilterDates(
            filters.dateFilter,
            loginUserState.timezone,
            loginUserState.fiscalYearStart
          );
    const csvTitle = `${dates.startDate} - ${dates.endDate}`;
    setCsvData({ data, columns: exportColumns, title: csvTitle });
  };

  const handleOpenExportModal = () => {
    getCsvData();
    setIsExportDataModalOpen(true);
  };

  const dateFilterForRefresh = filters?.dateFilter;

  // Refresh all charts
  useEffect(() => {
    refreshData({ refreshScatter: true, refreshPie: true });
  }, [performance, activeUserId, dateFilterForRefresh]);

  // Refresh all but pie and scatter chart data
  useEffect(() => {
    refreshData({ refreshScatter: false, refreshPie: false });
  }, [activePerformanceIndex]);

  // Refresh all but scatter chart data
  useEffect(() => {
    refreshData({ refreshScatter: false, refreshPie: true });
  }, [graphDisplay]);

  useEffect(() => {
    if (listingData.length - 1 < activePerformanceIndex) {
      setActivePerformanceIndex(0);
    }
  }, [activePerformanceIndex, listingData]);

  useEffect(() => {
    if (typeof activeUserId !== "undefined") {
      setActivePerformanceIndex(0);
    }
  }, [activeUserId]);

  const syncOptionsAndFilter = async (_filters, changeURL = true) => {
    try {
      const response = await postAPICall(FILTER_PARAMS, true, {
        filters: {
          filterLocations: _filters?.location?.map((lo) => lo.id) || [],
          filterTeams: _filters?.team?.map((lo) => lo.id) || [],
          filterRoles: _filters?.role?.map((lo) => lo.id) || [],
          filterUsers: _filters?.user?.map((lo) => lo.userCompanyLinkId) || [],
          filterReportsTo: _filters?.reportsTo?.map((lo) => lo.id) || [],
          dateFilter: _filters?.dateFilter,
        },
      });
      if (response?.data?.success) {
        const user = response.data.data.users;
        const { reportsTo } = response.data.data;
        const role = response.data.data.roles;
        const team = response.data.data.teams;
        const teamLocation = response.data.data.locations;
        const optionObj = {
          team,
          location: teamLocation,
          user,
          role,
          reportsTo,
          dateFilter: DATE_FILTER_OPTIONS,
        };
        const updatedFilter = { daysOfWeek: _filters.daysOfWeek };
        Object.keys(optionObj).forEach((key) => {
          if (Array.isArray(optionObj[key]) && Array.isArray(_filters[key])) {
            const arr1 = optionObj[key].map((obj) => obj.id);
            const arr2 = _filters[key];
            updatedFilter[key] = arr2.filter((arr2Obj) => arr1.includes(arr2Obj.id));
          }
        });
        if (DATE_FILTER_OPTIONS.includes(_filters.dateFilter)) {
          updatedFilter.dateFilter = _filters.dateFilter;
        }
        setFilters({ ...updatedFilter });
        setOptions(optionObj);

        if (history.pushState && changeURL) {
          let Qstring = "";
          // eslint-disable-next-line no-restricted-syntax
          for (const key in updatedFilter) {
            if (typeof updatedFilter[key] === "string") {
              Qstring += `&${key}=${updatedFilter[key]}`;
            } else if (Array.isArray(updatedFilter[key]) && updatedFilter[key].length) {
              // eslint-disable-next-line no-loop-func, no-return-assign
              updatedFilter[key].map((l) => (Qstring += `&${key}=${l.label}`));
            }
          }
          Qstring = Qstring.slice(1);
          const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${Qstring}`;
          window.history.pushState({ path: newurl }, "", newurl);
        }
      } else if (response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text:
              response?.response?.data?.message || response.message || "Could not retrive data!",
          }),
          {
            variant: "custom",
          }
        );
      }
    } catch (error) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: error?.response?.data?.message || error.message || "Could not retrive data!",
        }),
        {
          variant: "custom",
        }
      );
    }
  };

  const fetchParamsAndSetFilterFromURL = async (id) => {
    try {
      qparams = new URLSearchParams(window.location.search);
      QParamsObj = {
        location: qparams?.getAll("location") || [],
        team: qparams?.getAll("team") || [],
        user: qparams?.getAll("user") || [],
        role: qparams?.getAll("role") || [],
        reportsTo: qparams?.getAll("reportsTo") || [],
        dateFilter: qparams?.get("dateFilter")
          ? DATE_FILTER_OPTIONS.find(
              (filter) => filter?.toLowerCase() === qparams?.get("dateFilter")?.toLowerCase()
            ) || "This Week"
          : "This Week",
        daysOfWeek: qparams?.get("daysOfWeek") || defaultDaysOfWeek,
      };

      const response = await postAPICall(FILTER_PARAMS, true, {
        filters: {
          filterLocations: [],
          filterTeams: [],
          filterRoles: [],
          filterUsers: [],
          filterReportsTo: [],
        },
      });
      if (response?.data?.success) {
        const user = response.data.data.users;
        const { reportsTo } = response.data.data;
        const role = response.data.data.roles;
        const team = response.data.data.teams;
        const teamLocation = response.data.data.locations;
        const optionObj = {
          team,
          location: teamLocation,
          user,
          role,
          reportsTo,
          dateFilter: DATE_FILTER_OPTIONS,
        };

        const opObj = { daysOfWeek: QParamsObj.daysOfWeek };
        if (Object.keys(optionObj).length > 0) {
          Object.keys(optionObj).forEach((key) => {
            if (Array.isArray(QParamsObj[key])) {
              opObj[key] = QParamsObj[key]
                .map((fl) => optionObj[key].find((ol) => ol.label === fl))
                .filter((o) => o);
            } else if (DATE_FILTER_OPTIONS.includes(QParamsObj[key])) {
              opObj[key] = QParamsObj[key];
            }
          });
          syncOptionsAndFilter({ ...opObj });
        }

        fetchPerformance(opObj, id);
      } else if (response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text:
              response?.response?.data?.message || response.message || "Could not retrive data!",
          }),
          {
            variant: "custom",
          }
        );
      }
    } catch (error) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: error?.response?.data?.message || error.message || "Could not retrive data!",
        }),
        {
          variant: "custom",
        }
      );
    }
  };

  const changeURL = (_filters) => {
    const optionObj = {
      team: options.team,
      location: options.location,
      user: options.user,
      role: options.role,
      reportsTo: options.reportsTo,
      dateFilter: DATE_FILTER_OPTIONS,
    };
    const updatedFilter = { daysOfWeek: _filters.daysOfWeek };
    Object.keys(optionObj).forEach((key) => {
      if (Array.isArray(optionObj[key]) && Array.isArray(_filters[key])) {
        const arr1 = optionObj[key].map((obj) => obj.id);
        const arr2 = _filters[key];
        updatedFilter[key] = arr2.filter((arr2Obj) => arr1.includes(arr2Obj.id));
      }
    });
    if (DATE_FILTER_OPTIONS.includes(_filters.dateFilter)) {
      updatedFilter.dateFilter = _filters.dateFilter;
    }

    setFilters({ ...updatedFilter });

    if (history.pushState) {
      let Qstring = "";
      // eslint-disable-next-line no-restricted-syntax
      for (const key in updatedFilter) {
        if (typeof updatedFilter[key] === "string") {
          Qstring += `&${key}=${updatedFilter[key]}`;
        } else if (Array.isArray(updatedFilter[key]) && updatedFilter[key].length) {
          // eslint-disable-next-line no-loop-func, no-return-assign
          updatedFilter[key].map((l) => (Qstring += `&${key}=${l.label}`));
        }
      }
      Qstring = Qstring.slice(1);
      const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${Qstring}`;
      window.history.pushState({ path: newurl }, "", newurl);
    }
  };

  const changeURLBasedOnFilter = (_filters) => {
    changeURL(_filters);
    fetchPerformance(_filters, loginUserState.id);
    setIsFilterEdited(true);
    if (createNewView) setCreateNewView(false);
  };

  useEffect(() => {
    const handleURL = () => {
      let isURLEmpty = true;
      let newFilter = {
        dateFilter: "This Week",
        daysOfWeek: defaultDaysOfWeek,
      };

      Object.keys(QParamsObj).forEach((key) => {
        if (QParamsObj[key].length) {
          isURLEmpty = false;
        }
      });

      if ((isURLEmpty || !window.location.search) && !isFilterEdited) {
        if (loginUserState?.defaultPermissionFilter) {
          const defaultFilter = JSON.parse(loginUserState?.defaultPermissionFilter || "{}");
          newFilter = defaultFilter;
          if (!newFilter.dateFilter) {
            newFilter.dateFilter = "This Week";
          }
          if (!newFilter.daysOfWeek) {
            newFilter.daysOfWeek = defaultDaysOfWeek;
          }
          // HERE 2nd PRIORITY WILL BE OF REPORTSTO
        } else if (loginUserState?.hasReportsTo) {
          newFilter.reportsTo = [
            { id: loginUserState.userCompanyLinkId, label: loginUserState?.name },
          ];
          syncOptionsAndFilter(newFilter);
          fetchPerformance(newFilter, loginUserState.id);
          return;
        } else if (loginUserState?.Team) {
          newFilter.team = [{ id: loginUserState.Team.id, label: loginUserState?.Team?.name }];
        } else {
          setCreateNewView(true);
        }
        syncOptionsAndFilter(newFilter);
        fetchPerformance(newFilter, loginUserState.id);
      } else {
        fetchParamsAndSetFilterFromURL();
      }
    };

    handleURL();
  }, []);

  const companyId = loginUserState?.companyId;
  useEffect(async () => {
    const result = await getAPICall(
      `${COMPANY_CONFIG}/${companyId}/${CONFIG_NAME.WORKING_DAYS}`,
      true
    );

    if (result?.data?.[CONFIG_NAME.WORKING_DAYS]?.value) {
      const toObj = result.data[CONFIG_NAME.WORKING_DAYS].value
        .split("")
        .reduce((dict, val, index) => {
          dict[index] = Number(val);
          return dict;
        }, {});
      setWorkingDays(toObj);
    }
  }, [companyId]);

  useEffect(() => {
    const components = [];
    Object.keys(filters).forEach((key) => {
      if (Array.isArray(filters[key]) && filters[key].length > 0) {
        components.push(
          <React.Fragment key={key}>
            <MDTypography
              variant="body1"
              sx={{ textTransform: "capitalize", mr: 1, color: "#4c4c4c", fontSize: "1rem" }}
            >
              {`${key === "reportsTo" ? "Reports To " : key}: `}
            </MDTypography>
            <MDTypography
              variant="body1"
              sx={{ fontStyle: "italic", color: "#7882a6", fontSize: ".9rem", mr: 2 }}
            >
              {Array.isArray(filters[key]) &&
                filters[key]?.map(
                  (appliedFilter, inx) =>
                    `${appliedFilter.label} ${inx !== filters[key].length - 1 ? "," : ""} `
                )}
            </MDTypography>
          </React.Fragment>
        );
      }
    });

    setFilterComponents(components);
  }, [filters]);

  const disableDates = (date) => {
    const day = date.getDay();
    return !workingDays[day];
  };

  const showErrorBadgeContent =
    dateFilter.toLowerCase().indexOf("quarter") < 0 && dateFilter.toLowerCase().indexOf("year") < 0
      ? "Daily Goal"
      : "Monthly Goal";

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {createNewView ? (
        <MDBox
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "80vh",
          }}
        >
          <MDTypography>Build your custom view</MDTypography>
          <MDButton
            color="primaryRed"
            onClick={() => {
              setIsFilterModalOpen(true);
            }}
          >
            Create custom view
          </MDButton>
        </MDBox>
      ) : (
        <MDBox py={3} position="relative">
          <Loader loading={loading} />

          {/* dropdown for filter */}
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
            spacing={2}
          >
            <Grid item xs={4} md={2}>
              <MDButton
                sx={{ minWidth: "100%", borderRadius: "2rem" }}
                color="primaryRed"
                onClick={() => setIsFilterModalOpen(true)}
              >
                Filter
              </MDButton>
            </Grid>

            <Grid item xs={8} md={8}>
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                spacing={2}
              >
                {filters.dateFilter === "Custom" && (
                  <Grid item xs={4}>
                    <Stack display="flex" flexDirection="row" gap="8px">
                      <MDDatePicker
                        input={{
                          placeholder: "Select start date",
                          label: "Start date",
                          value: displayDate(customDate.startDate),
                        }}
                        value={customDate.startDate}
                        options={{
                          formatDate: (date) => displayDate(date, "MM-DD-YYYY"),
                          disable: [
                            // eslint-disable-next-line func-names
                            disableDates,
                          ],
                        }}
                        onChange={(value) => {
                          customDate.startDate = moment(value[0])
                            .startOf("day")
                            .format("YYYY-MM-DD HH:mm:ss");
                          setCustomDate(customDate);
                          if (customDate.endDate) {
                            localStorage.setItem(
                              "performanceCustomDate",
                              JSON.stringify(customDate)
                            );
                            syncOptionsAndFilter({ ...filters }, true);
                            fetchPerformance({ ...filters }, loginUserState.id);
                          }
                        }}
                      />
                      <MDDatePicker
                        input={{
                          placeholder: "Select end date",
                          label: "End date",
                          value: displayDate(customDate.endDate),
                        }}
                        value={customDate.endDate}
                        options={{
                          formatDate: (date) => displayDate(date, "MM-DD-YYYY"),
                          disable: [
                            // eslint-disable-next-line func-names
                            disableDates,
                          ],
                        }}
                        onChange={(value) => {
                          customDate.endDate = moment(value[0])
                            .endOf("day")
                            .format("YYYY-MM-DD HH:mm:ss");
                          setCustomDate(customDate);
                          localStorage.setItem("performanceCustomDate", JSON.stringify(customDate));
                          syncOptionsAndFilter({ ...filters }, true);
                          fetchPerformance({ ...filters }, loginUserState.id);
                        }}
                      />
                    </Stack>
                  </Grid>
                )}

                <Grid item xs={8} md={3}>
                  <Autocomplete
                    disablePortal
                    disableClearable
                    id="combo-box-demo"
                    value={filters.dateFilter}
                    onChange={(_, filter) => {
                      setDateFilter(filter);
                      syncOptionsAndFilter({ ...filters, dateFilter: filter }, true);
                      fetchPerformance({ ...filters, dateFilter: filter }, loginUserState.id);
                    }}
                    options={DATE_FILTER_OPTIONS}
                    renderInput={(params) => <TextField {...params} label="Filter options" />}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <MDBox sx={{ display: "flex", justifyContent: "space-between" }}>
            <MDBox>
              <MDBox
                sx={{
                  display: "inline-flex",
                }}
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={displayTrend}
                      onChange={(_, checked) => {
                        setDisplayTrend(checked);
                      }}
                    />
                  }
                  label="Display Trendline"
                  labelPlacement="start"
                  sx={{
                    marginRight: "20px",
                  }}
                />
              </MDBox>
              <MDBox
                sx={{ textTransform: "capitalize", alignItems: "flex-end", flexWrap: "wrap" }}
                display="inline-flex"
              >
                {filterComponents}
              </MDBox>
            </MDBox>
            <MDBox>
              <MDButton
                color="secondaryBlue"
                sx={{ borderRadius: "2rem" }}
                onClick={handleOpenExportModal}
              >
                Export
              </MDButton>
            </MDBox>
          </MDBox>
          <MDBox mt={2} mb={3}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} lg={9} id="performanceBarGraph">
                {/* BAR GRAPH */}
                <Grid container>
                  <Grid item xs={8} sm={8} lg={9} xl={9}>
                    <Card
                      sx={{
                        borderRadius: "1rem 0px 0px 1rem",
                        height: "388px",
                        maxHeight: "390px",
                      }}
                      id="performanceBarGraphCardPart1"
                    >
                      <MDBox mt={2} sx={{ display: "flex", justifyContent: "space-between" }}>
                        <MDBox
                          sx={{
                            ml: 3,
                            display: "grid",
                          }}
                        >
                          {listingData[activePerformanceIndex] && (
                            <MDTypography variant="h6">
                              {listingData[activePerformanceIndex]}
                            </MDTypography>
                          )}

                          <MDBox
                            sx={{
                              display: "inline-flex",
                            }}
                          >
                            <MDTypography
                              variant="h6"
                              sx={{
                                fontWeight: 400,
                                fontSize: "0.85rem",
                                color: "#aaa",
                              }}
                            >
                              {graphDisplay === "achievedPointsBreakdown"
                                ? "Total Points"
                                : "Total KPIs"}
                            </MDTypography>
                            <MDTypography
                              variant="h6"
                              sx={{
                                fontWeight: 400,
                                fontSize: "1rem",
                                pl: 1,
                                position: "relative",
                                top: "-3px",
                                color: generateColorFromString(listingData[activePerformanceIndex]),
                              }}
                            >
                              {totalDisplay.toLocaleString()}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                        <MDBox sx={{ display: "flex" }}>
                          {!!(activePerformanceIndex === 0 && showErrorBadgeContent) && (
                            <MDBadgeDot
                              color="error"
                              size="md"
                              badgeContent={showErrorBadgeContent}
                              sx={{
                                i: {
                                  background: "#344767",
                                },
                              }}
                            />
                          )}
                          <MDBadgeDot
                            color="secondary"
                            size="md"
                            badgeContent={
                              graphDisplay === "achievedPointsBreakdown"
                                ? "Achieved Points"
                                : "Tracked KPIs"
                            }
                            sx={{
                              i: {
                                background: generateColorFromString(
                                  listingData[activePerformanceIndex]
                                ),
                              },
                            }}
                          />
                        </MDBox>
                      </MDBox>
                      <MixedChart
                        icon={{ component: "insights" }}
                        chart={graphData}
                        displayTrend={displayTrend}
                        stacked={graphDisplay === "kpiBreakdown" && activePerformanceIndex === 0}
                      />
                    </Card>
                  </Grid>

                  <Grid item xs={4} sm={4} lg={3} xl={3}>
                    <Card
                      sx={{
                        borderRadius: "0px 1rem 1rem 0px",
                      }}
                      id="performanceBarGraphCardPart2"
                    >
                      <List
                        sx={{
                          width: "100%",
                          maxWidth: "100%",
                          height: "388px",
                          maxHeight: "390px",
                          overflowY: "auto",
                          padding: "10px",
                        }}
                      >
                        {/* <MDTypography variant="h6" p={0.5} mt={1}>
                          Select to view the performance
                        </MDTypography> */}
                        {listingData?.map((item, index) => (
                          // eslint-disable-next-line react/no-array-index-key
                          <Box key={index}>
                            <Divider variant="inset" component="li" sx={{ my: 0.15 }} />
                            <ListItem
                              onClick={() => {
                                if (activePerformanceIndex !== index) {
                                  setActivePerformanceIndex(index);
                                }
                              }}
                              sx={{
                                background: activePerformanceIndex === index && "#e1e1e1",
                                py: 0,
                                borderRadius: "0.2rem",
                                cursor: "pointer",
                              }}
                            >
                              <MDBox
                                sx={{
                                  py: 0.5,
                                  display: "flex",
                                }}
                              >
                                <MDBadgeDot
                                  color="warning"
                                  size="lg"
                                  badgeContent=""
                                  sx={{
                                    p: 0.5,
                                    i: {
                                      background: generateColorFromString(item),
                                    },
                                  }}
                                />
                                <MDTypography
                                  sx={{
                                    fontSize: "0.9rem",
                                    fontWeight: "400",
                                    lineHeight: "1.25",
                                  }}
                                >
                                  {item}
                                </MDTypography>
                              </MDBox>
                            </ListItem>
                          </Box>
                        ))}
                      </List>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>

              {/* DONUT */}
              <Grid item xs={12} sm={12} lg={3}>
                <BreakDownCharts
                  data={pieChartData}
                  graphDisplay={graphDisplay}
                  setGraphDisplay={setGraphDisplay}
                />
              </Grid>
            </Grid>
          </MDBox>
          <ListingTable
            dateFilter={dateFilter}
            dateFormat={loginUserState.dateFormat}
            data={tableData}
            setActiveUserId={setActiveUserId}
            activeUserId={activeUserId}
            fetchUserPerformance={() => {
              fetchPerformance(filters, loginUserState.id);
            }}
          />
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={12} id="performanceAnalytics">
              <PerformanceAnalytics activeUserId={activeUserId} />
            </Grid>
            <Grid item xs={12} xl={6}>
              <Card
                sx={{
                  p: "1rem",
                  height: "600px",
                  mt: "24px",
                }}
              >
                <ConversionFunnel conversionFunnelId={1} />
              </Card>
            </Grid>
            {/* <Grid item xs={12} xl={6}>
              <Card
                sx={{
                  p: "1rem",
                  height: "600px",
                  mt: "24px",
                }}
              >
                <ConversionFunnel conversionFunnelId={2} />
              </Card>
            </Grid> */}
          </Grid>
        </MDBox>
      )}
      {isFilterModalOpen && (
        <FilterModal
          open={isFilterModalOpen}
          setFilters={setFilters}
          filters={filters}
          options={options}
          setOptions={setOptions}
          setCreateNewView={setCreateNewView}
          changeURLBasedOnFilter={changeURLBasedOnFilter}
          syncOptionsAndFilter={syncOptionsAndFilter}
          handleClose={() => setIsFilterModalOpen((prev) => !prev)}
          defaultDaysOfWeek={defaultDaysOfWeek}
        />
      )}
      <ExportReportModal
        open={isExportDataModalOpen}
        handleClose={handleExportDataModalClose}
        filters={filters}
        csvData={csvData}
        filterDates={filterDates}
      />
    </DashboardLayout>
  );
}

export default Performance;
